export default __webpack_public_path__ + "static/media/gmi_logo.41a5e491.png";